import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives } from "vue"
import _imports_0 from '../assets/images/close.png'


const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_3 = { class: "input-icon" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "info"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "split-bill",
    style: _normalizeStyle(_ctx.style)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.activateSplit && _ctx.activateSplit(...args)))
      }, "Split Bill" + _toDisplayString(_ctx.splitAmount), 1),
      (_ctx.active)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _imports_0,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.deactiveSplit && _ctx.deactiveSplit(...args)))
          }))
        : _createCommentVNode("", true)
    ]),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("input", {
        inputmode: "decimal",
        type: "text",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.amount) = $event)),
        placeholder: "Enter the amount",
        onKeyup: _cache[3] || (_cache[3] = ($event: any) => (_ctx.message='')),
        onBlur: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onEnterAmount && _ctx.onEnterAmount(...args))),
        style: _normalizeStyle(_ctx.inputStyle)
      }, null, 36), [
        [_vModelText, _ctx.amount]
      ]),
      (_ctx.amount!='')
        ? (_openBlock(), _createElementBlock("i", _hoisted_4, "$"))
        : _createCommentVNode("", true)
    ]),
    (_ctx.message!='')
      ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.message), 1))
      : _createCommentVNode("", true)
  ], 4))
}